import { Tooltip } from "@freightsimple/ui-core/Feedback/Tooltip";
import { formatPrice } from "@/Helpers/formatPrice";

interface BeforeCouponTagProps {
  priceBeforeCoupon: number;
  size?: "small" | "medium" | "large" | undefined;
}

function Tag_({
  size,
  children,
}: {
  size: "small" | "medium" | "large";
  children: React.ReactNode;
}) {
  const sizeClasses =
    size === "large"
      ? "rounded-[4px] px-[8px] py-[4px] text-[14px]"
      : "rounded-[2px] px-[4px] py-[2px] text-[11px]";
  return (
    <div className={`bg-gold text-right text-on-bright ${sizeClasses}`}>
      {children}
    </div>
  );
}

const QuotesBeforeCouponTag = (props: BeforeCouponTagProps) => {
  const { priceBeforeCoupon, size = "medium" } = props;
  return size === "small" ? (
    <Tooltip
      side="right"
      content={
        <div className="p-[10px]">
          <div className="mb-[7px] text-[14px] font-light text-foreground">
            {formatPrice(priceBeforeCoupon)} Before Coupon
          </div>
        </div>
      }
    >
      <Tag_ size={size}>
        <b> ${formatPrice(priceBeforeCoupon)}</b>
      </Tag_>
    </Tooltip>
  ) : (
    <Tag_ size={size}>
      <b> ${formatPrice(priceBeforeCoupon)}</b> Before coupon
    </Tag_>
  );
};

export default QuotesBeforeCouponTag;
